import { CTBase } from '@ctsolution/ct-base';
import { TaskType } from '../enum/task-type';

export class Task extends CTBase<Task> {

  Oid?: number;
  Name: string | null = null;
  Description: string | null = null;
  Effort: number | null = null;
  InvoiceNumber: string | null = null;
  InvoiceTotal: number | null = null;
  InvoiceVAT: number | null = null;
  InvoiceComments: string | null = null;
  InvoiceDate: Date | null = null;
  StartDate: Date | null = null;
  EndDate: Date | null = null;
  CreateAt: Date | null = null;
  UpdateAt: Date | null = null;

  State: { Oid: number, Code?: string, Description?: string, Name?: string } | null = null;
  InvoiceState: { Oid: number, Code?: string, Description?: string } | null = null;
  SystemUser: { Oid: number, NameSurname?: string } | null = null;
  Type: { Oid: number, Name?: string, MacroType? : TaskType } | null = null;
  WorkOrder: any | null = null;

  CreatedBy: { Oid: number } | null = null;
  UpdatedBy: { Oid: number } | null = null;

  private constructor();
  private constructor(model?: Task);
  private constructor(model?: Task) {

    super();

    if (model) this.getClass(model);

  }

  public static create = (model?: Task) => new Task(model);

  setOid(value?: number) {
    this.Oid = value;
    return this;
  }

  setName(value: string | null) {
    this.Name = value;
    return this;
  }

  setDescription(value: string | null) {
    this.Description = value;
    return this;
  }

  setEffort(value: number | null) {
    this.Effort = value;
    return this;
  }

  setInvoiceNumber(value: string | null) {
    this.InvoiceNumber = value;
    return this;
  }

  setInvoiceTotal(value: number | null) {
    this.InvoiceTotal = value;
    return this;
  }

  setInvoiceVAT(value: number | null) {
    this.InvoiceVAT = value;
    return this;
  }

  setInvoiceComments(value: string | null) {
    this.InvoiceComments = value;
    return this;
  }

  setInvoiceDate(value: Date | null) {
    this.InvoiceDate = value;
    return this;
  }

  setStartDate(value: Date | null) {
    this.StartDate = value;
    return this;
  }

  setEndDate(value: Date | null) {
    this.EndDate = value;
    return this;
  }

  setStateOid(value: number | null) {
    this.State = value !== null ? { Oid: value } : null;
    return this;
  }

  setInvoiceStateOid(value: number | null) {
    this.InvoiceState = value !== null ? { Oid: value } : null;
    return this;
  }

  setSystemUserOid(value: number | null) {
    this.SystemUser = value !== null ? { Oid: value } : null;
    return this;
  }

  setTypeOid(value: number | null) {
    this.Type = value !== null ? { Oid: value } : null;
    return this;
  }

  setWorkOrderOid(value: number | null) {
    this.WorkOrder = value !== null ? { Oid: value } : null;
    return this;
  }

  setCreatedByOid(value: number | null) {
    this.CreatedBy = value !== null ? { Oid: value } : null;
    return this;
  }

  setUpdatedByOid(value: number | null) {
    this.UpdatedBy = value !== null ? { Oid: value } : null;
    return this;
  }
}